import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import { getBusinessName } from '../../lib/utils'
import FontAwesome from "react-fontawesome"
import ClientDocuments from "../fragments/ClientDocuments"
import Authenticated from "../../lib/Authenticated"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import moment from "moment"
import SimpleCardRow from "../fragments/SimpleCardRow"
import LoanSmallCard from "../fragments/LoanSmallCard"

class BusinessDetails extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  componentDidMount() {
    const { getBusinessLoans, business } = this.props
    getBusinessLoans(business.id)
  }

  showRow = (name, value, className) =>
    <SimpleCardRow name={ name } value={ value } className={ className } />

  renderButtonToolbar = id => {

    if(!this.isAdmin) return null;
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/businesses/${id}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button>

        <Button bsStyle="success" onClick={() => browserHistory.push('/businesses/create')}
          className="ml-10">
          <FontAwesome name='plus-circle' /> New Business
        </Button>
      </div>
    )
  }

  showBusiness = business => {

    if(!business) return null

    const { id, name, businessId, contactName, phoneNumber, email, createdOn, documents } = business
    return <Col md={8} className='detail-content'>

      <h2 className="blue">
        { name } - { businessId }
      </h2>

      { this.showRow('Name', name) }

      { this.showRow('Business ID', businessId) }

      { this.showRow('Contact Name', contactName) }

      { this.showRow('Phone Number', phoneNumber) }

      { this.showRow('Email', email) }

      { this.showRow('Created On',
        createdOn ? moment(createdOn).format('lll') : '',
        'gray font-size-13'
      )}   

      <ClientDocuments documents={ documents } />

      { this.renderButtonToolbar(id) }

    </Col>
  }

  render() {
    const { business, businessLoans } = this.props,
    dataBreadCrumbs = [{ url: '/businesses', title: 'Businesses' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ getBusinessName(business) } data={ dataBreadCrumbs } />

        <Row>
          <Col md={4}>

            <div className="align-center">
              <FontAwesome name="building-o" size="3x" className="detail-icon" />
            </div>
            <LoanSmallCard loans={ businessLoans } />
          </Col>

          { this.showBusiness(business) }
        </Row>
      </div>
    )
  }
}

BusinessDetails.propTypes = {
  business: PropTypes.object.isRequired,
}

export default BusinessDetails



// WEBPACK FOOTER //
// ./src/components/Business/BusinessDetails.js